import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringScheduleTypes = api(async function getAuthoringScheduleTypes() {
    return query(
        gql`
            query GetAuthoringScheduleTypes {
                getAuthoringScheduleTypes {
                    id
                    name
                }
            }
        `,
        {},
        { returns: "getAuthoringScheduleTypes" }
    )
})
